import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle
} from '@/components/ui/dialog.tsx';
import { Button } from '@/components/ui/button.tsx';

interface Interface {
	show: boolean;
	confirmation: string;
	proceed: (val: boolean) => void;
}
export const Confirmation = ({ show, confirmation, proceed }: Interface) => (
	<Dialog open={show} onOpenChange={() => proceed(false)}>
		<DialogContent className={'rounded-2xl p-6 max-w-sm mx-auto'}>
			<DialogHeader className={'space-y-1'}>
				<DialogTitle className={'text-lg font-semibold'}>
					Attention
				</DialogTitle>
				<DialogDescription className={'text-sm text-muted-foreground leading-relaxed'}>
					{confirmation}
				</DialogDescription>
			</DialogHeader>
			<DialogFooter className={'flex flex-row gap-3 pt-2'}>
				<Button
					className={'flex-1'}
					onClick={() => proceed(false)}
					variant={'destructive'}>
					Non
				</Button>
				<Button
					className={'flex-1'}
					onClick={() => proceed(true)}>
					Oui
				</Button>
			</DialogFooter>
		</DialogContent>
	</Dialog>
);
